// React
import React from 'react';
// External libraries
import {
    Container, Row, Col, Image
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Internal
import FormForgotPassword from 'components/auth/FormForgotPassword';
import FormResetPassword from 'components/auth/FormResetPassword';
import FormVerifyCode from 'components/auth/FormVerifyCode';
import config from 'config/config';
import forgotPasswordSteps from 'constants/forgotPasswordSteps';
import BrandService from 'services/brand';
// Styles
import './styles.scss';
// Images
import paw from 'assets/images/paw.png';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        const steps = Object.values(forgotPasswordSteps).reverse();
        // steps.pop();
        this.state = {
            steps,
            currentStep: steps[steps.length - 1],
            email: '',
            verificationCode: '',
            imgSrc: ''
        };
        this.getBrandImage();
        this.handleVerificationError = this.handleVerificationError.bind(this);
    }

    handleVerificationError() {
        this.setState({ currentStep: 'verify-code' });
      }

    /**
     * Handles the action after the form submission of the forms
     * @param {Object} formDataOBj - Contains the key value to store the state data e.g. {email: value}
     */
    onSubmit(formDataOBj) {
        this.setState(formDataOBj);
        if (this.state.currentStep === "verify-code") {
            this.setState({ currentStep: "new-password" })
        } else {
            this.nextStep();
        }
    }

    /**
     * Gets the brand logo to display in the app
     */
    getBrandImage() {
        BrandService.getBrand()
            .then((response) => {
                this.setState({ imgSrc: response.data.brand_logo_link });
            }).catch((err) => {
                console.error(err);
            });
    }

    nextStep() {
        this.setState((prevState) => {
            const { steps } = prevState;
            if (steps.length) {
                steps.pop();
                return {
                    steps,
                    currentStep: steps[steps.length - 1]
                };
            }
        });
    }

    render() {
        return (
            <Container fluid className="login-page-wrapper">
                <Row className="login-page">
                    <Col className="left-section" md="auto" />
                    <Col className="right-section">
                        <div className="login-form-wrapper">
                            <div className="logo-wrapper">
                                <Image
                                    alt={config.webTitle}
                                    src={this.state.imgSrc}
                                    className="login-logo"
                                    height="40"
                                />
                            </div>

                            <div className="heading-wrapper">
                                <h1 className="page-heading">Reset your password</h1>
                                {
                                    this.state.currentStep === forgotPasswordSteps.sendEmail
                                        ? (
                                            <p className="reset-pwd-txt">
                                                To proceed, please enter your username.
                                                We’ll send you an email to reset your password.
                                            </p>
                                        ) : null
                                }
                                {
                                    this.state.currentStep === forgotPasswordSteps.verifyCode
                                        ? (
                                            <p className="reset-pwd-txt">
                                                An email containing a verification code has been sent.
                                                Please check your inbox and enter the verification code here.
                                            </p>
                                        ) : null
                                }
                                {
                                    this.state.currentStep === forgotPasswordSteps.newPassword
                                        ? (
                                            <p className="reset-pwd-txt">
                                                Please enter a new password. It is your responsibility to keep this password secure.
                                            </p>
                                        ) : null
                                }
                            </div>

                            {
                                this.state.currentStep === forgotPasswordSteps.sendEmail
                                    ? (
                                        <div className="form-wrapper">
                                            <FormForgotPassword
                                                onSubmit={(email) => this.onSubmit({ email })}
                                            />
                                        </div>
                                    ) : null
                            }
                            {
                                this.state.currentStep === forgotPasswordSteps.verifyCode
                                    ? (
                                        <div className="form-wrapper">
                                            <FormVerifyCode
                                                onSubmit={(verificationCode) => this.onSubmit({ verificationCode })}
                                            />
                                        </div>
                                    ) : null
                            }
                            {
                                this.state.currentStep === forgotPasswordSteps.newPassword
                                    ? (
                                        <div className="form-wrapper">
                                            <FormResetPassword
                                                email={this.state.email}
                                                verificationCode={this.state.verificationCode}
                                                onVerificationError={this.handleVerificationError}
                                            />
                                        </div>
                                    ) : null
                            }
                            <Image alt="Pet paw" src={paw} className="image-paw" />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(ForgotPassword);
